import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-webtime-page',
    templateUrl: './webtime-page.component.html'
})
export class WebTimePageComponent implements OnInit {

    constructor( ) { }

    ngOnInit(): void { }
}
